import React from 'react';

type StatusType =
  | 'available' |'en-route' |'on-site' |'returning' |'maintenance' |'offline' |'dispatched' |'scheduled' |'in-transit' |'completed' |'invoiced' |'assigned' |'active' |'inactive' |'critical' |'warning' |'connected' |'disconnected' |'syncing';

const statusConfig: Record<StatusType, { label: string; className: string; dot: string }> = {
  available: { label: 'Available', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30', dot: 'bg-emerald-400' },
  'en-route': { label: 'En Route', className: 'bg-sky-500/15 text-sky-400 border-sky-500/30', dot: 'bg-sky-400' },
  'on-site': { label: 'On Site', className: 'bg-violet-500/15 text-violet-400 border-violet-500/30', dot: 'bg-violet-400' },
  returning: { label: 'Returning', className: 'bg-amber-500/15 text-amber-400 border-amber-500/30', dot: 'bg-amber-400' },
  maintenance: { label: 'Maintenance', className: 'bg-orange-500/15 text-orange-400 border-orange-500/30', dot: 'bg-orange-400' },
  offline: { label: 'Offline', className: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30', dot: 'bg-zinc-400' },
  dispatched: { label: 'Dispatched', className: 'bg-blue-500/15 text-blue-400 border-blue-500/30', dot: 'bg-blue-400' },
  scheduled: { label: 'Scheduled', className: 'bg-indigo-500/15 text-indigo-400 border-indigo-500/30', dot: 'bg-indigo-400' },
  'in-transit': { label: 'In Transit', className: 'bg-sky-500/15 text-sky-400 border-sky-500/30', dot: 'bg-sky-400' },
  completed: { label: 'Completed', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30', dot: 'bg-emerald-400' },
  invoiced: { label: 'Invoiced', className: 'bg-teal-500/15 text-teal-400 border-teal-500/30', dot: 'bg-teal-400' },
  assigned: { label: 'Assigned', className: 'bg-blue-500/15 text-blue-400 border-blue-500/30', dot: 'bg-blue-400' },
  active: { label: 'Active', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30', dot: 'bg-emerald-400' },
  inactive: { label: 'Inactive', className: 'bg-zinc-500/15 text-zinc-400 border-zinc-500/30', dot: 'bg-zinc-400' },
  critical: { label: 'Critical', className: 'bg-red-500/15 text-red-400 border-red-500/30', dot: 'bg-red-400' },
  warning: { label: 'Warning', className: 'bg-amber-500/15 text-amber-400 border-amber-500/30', dot: 'bg-amber-400' },
  connected: { label: 'Connected', className: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30', dot: 'bg-emerald-400' },
  disconnected: { label: 'Disconnected', className: 'bg-red-500/15 text-red-400 border-red-500/30', dot: 'bg-red-400' },
  syncing: { label: 'Syncing', className: 'bg-sky-500/15 text-sky-400 border-sky-500/30', dot: 'bg-sky-400' },
};

interface StatusBadgeProps {
  status: StatusType;
  showDot?: boolean;
  size?: 'sm' | 'md';
}

export default function StatusBadge({ status, showDot = true, size = 'sm' }: StatusBadgeProps) {
  const config = statusConfig[status] ?? statusConfig.offline;
  return (
    <span className={`inline-flex items-center gap-1 border rounded-full font-medium ${size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'} ${config.className}`}>
      {showDot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${config.dot}`} />}
      {config.label}
    </span>
  );
}